import { Box, BoxProps } from "@mui/material";
import React from "react";

interface Props extends BoxProps {
  mobile?: boolean;
  desktop?: boolean;
  children?: React.ReactNode;
}

/**
 * Surround children with box where display has "none" or inherit based
 * on if the breakpoints alight with mobile or desktop. Component needs
 * to have props mobile or desktop set depending on if the children should
 * be visible in desktop or mobile view only
 * @returns React FC component
 */
const Display: React.FC<Props> = ({
  mobile = false,
  desktop = false,
  children,
  ...rest
}: Props) => {
  const xs = desktop ? "none" : "inherit";
  const md = mobile ? "none" : "inherit";

  return (
    <Box
      display={{
        xs,
        md,
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
export default Display;
